<template>
  <Teleport to="body">
    <Transition name="confirm-modal-glass">
      <div
        v-if="show"
        class="confirm-modal-overlay"
        :class="[
          `confirm-modal-overlay--${tone}`,
          { 'confirm-modal-overlay--alert': !showCancel }
        ]"
        @click.self="onOverlayClick"
      >
        <div
          class="confirm-modal"
          :class="[
            `confirm-modal--${tone}`,
            { 'confirm-modal--alert': !showCancel }
          ]"
          role="dialog"
          aria-modal="true"
          @click.stop
        >
          <div class="confirm-modal-shine" aria-hidden="true"></div>
          <div class="confirm-modal-header">
            <div class="confirm-modal-icon" aria-hidden="true">
              <i :class="iconClass"></i>
            </div>
            <h3 v-if="title" class="confirm-modal-title">{{ title }}</h3>
          </div>
          <div class="confirm-modal-body">
            <div v-if="clientName" class="confirm-modal-client-name">
              {{ clientName }}
            </div>
            <p class="confirm-modal-message">
              <slot name="message">{{ message }}</slot>
            </p>
          </div>
          <div
            class="confirm-modal-footer"
            :class="{ 'confirm-modal-footer--single': !showCancel }"
          >
            <button
              v-if="showCancel"
              type="button"
              class="confirm-modal-btn confirm-modal-btn-cancel"
              @click="$emit('cancel')"
            >
              {{ cancelText }}
            </button>
            <button type="button" class="confirm-modal-btn confirm-modal-btn-confirm" @click="$emit('confirm')">
              {{ confirmText }}
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
import './ConfirmModal.css';

export default {
  name: 'ConfirmModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Confirm Action'
    },
    message: {
      type: String,
      default: ''
    },
    clientName: {
      type: String,
      default: ''
    },
    confirmText: {
      type: String,
      default: 'Confirm'
    },
    cancelText: {
      type: String,
      default: 'Cancel'
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    closeOnOverlay: {
      type: Boolean,
      default: true
    },
    /** danger = delete/destructive; accent = switch/continue (teal glass) */
    tone: {
      type: String,
      default: 'danger',
      validator: (value) => ['danger', 'accent'].includes(value)
    },
    icon: {
      type: String,
      default: ''
    }
  },
  emits: ['confirm', 'cancel'],
  computed: {
    iconClass() {
      if (this.icon) return this.icon;
      return this.tone === 'accent'
        ? 'bi bi-arrow-left-right'
        : 'bi bi-exclamation-triangle';
    }
  },
  methods: {
    onOverlayClick() {
      if (!this.closeOnOverlay) return;
      if (this.showCancel) {
        this.$emit('cancel');
        return;
      }
      this.$emit('confirm');
    }
  }
}
</script>
